export const getPaperOverrides = theme => {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.elevation1,
          // boxShadow: "0px 2px 6px -2px rgba(0, 0, 0, 0.06) !important",
          borderRadius: 16
        }
      }
    }
  };
};